/**
 * Проверка, можно ли поднять worker-prescale в текущем окружении.
 * Возвращает 'ok' либо причину недоступности (для логов/диагностики).
 */
export function detectWorkerSupport(): string {
    if (typeof window === 'undefined') {
        return 'no-window';
    }
    if (typeof Worker === 'undefined') {
        return 'no-worker';
    }
    if (!('MediaStreamTrackProcessor' in window)) {
        return 'no-mstp';
    }
    if (typeof OffscreenCanvas === 'undefined' || !('transferToImageBitmap' in OffscreenCanvas.prototype)) {
        return 'no-offscreen';
    }
    return 'ok';
}
